import React, { useEffect, useState } from 'react';
import SystemNotificationList from './SystemNotificationList';
import SystemNotificationEditModal from './SystemNotificationEditModal';
import { GetJson } from '@awp/helpers/fetchReact';
import { FORM_MODE, REST_API } from '@awp/constants';
import { AwpContainer } from '../Common/AwpContainer';

const SystemNotification = () => {
  const [mode, setMode] = useState('list');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(true);
  const [notificationMessageData, setNotificationMessageData] = useState(null);

  useEffect(() => {
    setLoading(true);
    const url = REST_API.SYSTEM_NOTIFICATION_MESSAGES;

    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      });
  }, []);

  const tableProps = {
    setData,
    data,
    loading,
    setMode,
    notificationMessageData,
    setNotificationMessageData,
  };

  const editProps = {
    setMode,
    mode,
    data,
    setData,
    setLoading,
    loading,
    notificationMessageData,
    setNotificationMessageData,
  };

  return (
    <AwpContainer>
      {mode === FORM_MODE.LIST ? (
        <SystemNotificationList {...tableProps} />
      ) : (
        <>
          <SystemNotificationList {...tableProps} />
          <SystemNotificationEditModal
            showNotificationModal={showNotificationModal}
            setShowNotificationModal={setShowNotificationModal}
            editProps={editProps}
          />
        </>
      )}
    </AwpContainer>
  );
};

export default SystemNotification;
